// Thin wrappers over the generated `effect-packs` orval hooks (parity: EffectPackReviewViewModel).
// Unwrapping happens via `selectData` per the envelope rule; approve/reject invalidate the review
// queue so the list refetches (CMP: `.onSuccess { reload() }`).
import { useQueryClient } from '@tanstack/react-query';
import { selectData } from '@/api/envelope';
import {
  useListEffectPackCandidates,
  useApproveEffectPack as useApproveEffectPackMutation,
  useRejectEffectPack as useRejectEffectPackMutation,
  getListEffectPackCandidatesQueryKey,
} from '@/api/generated/effect-packs/effect-packs';

/** Stable query key for the review-queue list — reused for invalidation after approve/reject. */
export const EFFECT_PACK_CANDIDATES_QUERY_KEY = getListEffectPackCandidatesQueryKey();

/** Review-queue candidates (GET /admin/api/effect-packs/candidates), envelope-unwrapped. */
export function useEffectPackCandidates() {
  return useListEffectPackCandidates({
    query: { select: selectData },
  });
}

/** Approve: moves the template from STAGING to the published pack, then refetches the queue. */
export function useApproveEffectPack() {
  const qc = useQueryClient();
  return useApproveEffectPackMutation({
    mutation: {
      onSuccess: () => void qc.invalidateQueries({ queryKey: EFFECT_PACK_CANDIDATES_QUERY_KEY }),
    },
  });
}

/** Reject: drops the candidate from STAGING, then refetches the queue. */
export function useRejectEffectPack() {
  const qc = useQueryClient();
  return useRejectEffectPackMutation({
    mutation: {
      onSuccess: () => void qc.invalidateQueries({ queryKey: EFFECT_PACK_CANDIDATES_QUERY_KEY }),
    },
  });
}
